// regnskapsforer-nav-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'r1n.denied.title': 'Byråflaten er bare for regnskapsbyråets medlemmer',
  'r1n.denied.body': 'Klienter arbeider i sin egen foretaksflate og kan ikke åpne byråets klientoversikt, avstemming eller kontroll.',
  'r1n.denied.exit': 'Til regnskapet mitt',
});
